import type { UserProfile } from '@/features/Auth/auth.types'

export function hasEmail(profile: UserProfile | null | undefined): boolean {
  return (profile?.identityItems ?? []).some((item) => item.type === 'EMAIL')
}

export function hasPhone(profile: UserProfile | null | undefined): boolean {
  return (profile?.identityItems ?? []).some((item) => item.type === 'PHONE')
}

export function isKycNotStarted(profile: UserProfile | null | undefined): boolean {
  return profile?.kycStatus === 'NOT_STARTED'
}

export function isKycStarted(profile: UserProfile | null | undefined): boolean {
  return profile?.kycStatus === 'STARTED'
}

export function isKycPending(profile: UserProfile | null | undefined): boolean {
  return isKycNotStarted(profile) || isKycStarted(profile)
}

export function isKycApproved(profile: UserProfile | null | undefined): boolean {
  return profile?.kycStatus === 'APPROVED'
}

export function isKycPendingReview(profile: UserProfile | null | undefined): boolean {
  return profile?.kycStatus === 'PENDING'
}

export function isKycRejected(profile: UserProfile | null | undefined): boolean {
  return profile?.kycStatus === 'REJECTED'
}
